import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const FatigueEvolutionContext = createContext()

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const startDate = new Date(currentYear, currentMonth, 1)

const STATUSES = {
  badpred: { name: 'Ruim', type: 'bad', color: '#fd564e' },
  regularpred: { name: 'Regular', type: 'regular', color: '#ffe000' },
  goodpred: { name: 'Bom', type: 'good', color: '#62E751' },
}

export const GRANULARITY = {
  DAILY: 'daily',
  WEEKLY: 'week',
  MONTHLY: 'month',
  ANNUALLY: 'year',
}

export const FatigueEvolutionProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [dateRange, setDateRange] = useState([startDate, new Date()])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [onShift, setOnShift] = useState('Sim')
  const [inputValue, setInputValue] = useState('')
  const [granularity, setGranularity] = useState(GRANULARITY.WEEKLY)
  const [graphMessage, setGraphMessage] = useState(null)

  const renameStatusesNames = ({ data }) => {
    const renamed = data.map(output => {
      if (!STATUSES[output?.name]) return null

      return {
        ...output,
        name: STATUSES[output.name]?.name,
        type: STATUSES[output.name]?.type,
        color: STATUSES[output.name]?.color,
      }
    })

    return renamed.filter(data => data !== null)
  }

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const onChangeGranularity = event => {
    setGranularity(event.target.value)
  }

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getFatigueEvolution({
        date: dateRange,
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
        onShift,
        granularity,
      })

      const outputData = renameStatusesNames({ data: data.output })

      setData(outputData)
      setCategories(data.categories)
      setGraphMessage(data.graphMessage)
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getFatigueEvolutionFilters()

      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [dateRange, selectedFilterOptions, selectedUser?.id, onShift, granularity])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <FatigueEvolutionContext.Provider
      value={{
        data,
        loading,
        dateRange,
        onDateRangeChange: setDateRange,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        categories,
        onShift,
        onCheckOnShift: setOnShift,
        inputValue,
        onInputValueChange: setInputValue,
        granularity,
        onChangeGranularity,
        graphMessage,
      }}
    >
      {children}
    </FatigueEvolutionContext.Provider>
  )
}

export const useFatigueEvolution = () => {
  return useContext(FatigueEvolutionContext)
}
